import { history } from 'utils/history';

export const parseDistanceId = () => {
  const searchParams = new URLSearchParams(history.location.search);
  const distanceId = searchParams.get('distance');
  return distanceId;
};
